import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';

import { useReclassificationModal } from '../context/ReclassificationModalContext';
import RangesView from './RangesView';

const ReclassificationPartnerMode: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useReclassificationModal();

  const handleSearchPartnerByTerm = async (searchTerm: string) => {
    const options = await actions.handleSearchPartnerByTerm(searchTerm, true);
    return options;
  };

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="pay-amount">
          {t('SelectShareholderForReclass')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="partner-select-input"
            onChange={actions.handleChangePartner}
            onFetchData={handleSearchPartnerByTerm}
            value={data.selectedPartnerOption}
            placeholder={t('SearchPartner')}
            minimumInputLength={3}
            noDataLabelKey="NoPartnersHaveBeenFound"
            loadingLabelKey="LoadingPartners"
            errorLabelKey="ErrorLoadingPartners"
            defaultOptions={data.partnerOptions}
          />
        </div>
      </div>

      <RangesView />
    </>
  );
};

export default ReclassificationPartnerMode;
